import React from "react"
import {Redirect, Route, Switch} from "react-router-dom"
import {useAuthsState} from "../../app/auths/authsContext"
import ProductEditor from "../../app/product-editor/ProductEditor"
import {ProductEditorTranslationProvider} from "../../app/product-editor/productEditorTranslationContext"
import {SEASONAL_PASSES_BASE_URL} from "../../app/Routes"
import {PRODUCT_TYPE_SEASONAL_PASS} from "../../app/baseContext"
import ProductDetails from "../../app/product-details/ProductDetails"
import {SeasonalPassesList} from "./seasonal-passes-list/SeasonalPassesList"
import {SeasonalPassOverview} from "./SeasonalPassOverview"
import {useMuseumSelectorState} from "../../app/museum-selector/museumSelectorContext"
import {ROLES_VALUES} from "../../app/menu/MuseumSelector"

export const SeasonalPassesRoutes = () => {
    const {userIsAuthenticated} = useAuthsState()
    const {selectedMuseum} = useMuseumSelectorState()

    const getRoutes = () => {
        if (userIsAuthenticated) {
            return (
                <>
                    <Route exact
                           path={SEASONAL_PASSES_BASE_URL}>
                        {selectedMuseum?.role?.value >= ROLES_VALUES.EDITOR
                            ? <SeasonalPassOverview/>
                            : <Redirect to={`${SEASONAL_PASSES_BASE_URL}/list`}/>}
                    </Route>
                    <Route path={`${SEASONAL_PASSES_BASE_URL}/list`}>
                        <SeasonalPassesList/>
                    </Route>
                    <Route path={`${SEASONAL_PASSES_BASE_URL}/:id/details`}>
                        <ProductDetails type={PRODUCT_TYPE_SEASONAL_PASS}/>
                    </Route>
                    <Route path={`${SEASONAL_PASSES_BASE_URL}/:id/edit`}>
                        {selectedMuseum?.role?.value >= ROLES_VALUES.EDITOR
                            ? <ProductEditorTranslationProvider>
                                <ProductEditor type={PRODUCT_TYPE_SEASONAL_PASS}/>
                            </ProductEditorTranslationProvider>
                            : <Redirect to={`${SEASONAL_PASSES_BASE_URL}/list`}/>}
                    </Route>
                </>
            )
        } else {
            return null
        }
    }

    return (
        <Switch>
            {getRoutes()}
        </Switch>
    )
}